var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterCategory = function SvgFilterCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M6.5 8a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0M8 11a3 3 0 1 1 0-5.999A3 3 0 0 1 8 11m-1.5 5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0M8 19a3 3 0 1 1 0-6 3 3 0 0 1 0 6m8-9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M19 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-3 4.5c.416 0 .75.334.75.75v2h2c.416 0 .75.334.75.75s-.334.75-.75.75h-2v2c0 .416-.334.75-.75.75a.75.75 0 0 1-.75-.75v-2h-2a.75.75 0 0 1-.75-.75c0-.416.334-.75.75-.75h2v-2c0-.416.334-.75.75-.75"
  })));
};
export default SvgFilterCategory;